import React from "react";

/**
 * Fallback UI shown when a React render error is caught by Sentry's ErrorBoundary.
 * Styled to match MMNTM's dark/cyber aesthetic. The error has already been
 * reported to Sentry by the time this component renders.
 */
export default function SentryFallback({ error, resetError, eventId }) {
  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "2rem",
        textAlign: "center",
        backgroundColor: "#0a0a0a",
        color: "#ffffff",
        fontFamily: "system-ui, -apple-system, sans-serif",
      }}
    >
      <div style={{ maxWidth: "480px" }}>
        <h1
          style={{
            fontSize: "1.75rem",
            fontWeight: 700,
            marginBottom: "0.75rem",
            letterSpacing: "-0.02em",
          }}
        >
          Something broke.
        </h1>

        <p
          style={{
            fontSize: "1rem",
            opacity: 0.7,
            marginBottom: "2rem",
            lineHeight: 1.5,
          }}
        >
          We've been notified and are looking into it. Try again, or refresh the page.
        </p>

        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            onClick={resetError}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "#ffffff",
              color: "#0a0a0a",
              border: "none",
              borderRadius: "0.5rem",
              fontSize: "0.9rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Try again
          </button>

          <button
            onClick={() => window.location.assign("/")}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: "transparent",
              color: "#ffffff",
              border: "1px solid rgba(255,255,255,0.2)",
              borderRadius: "0.5rem",
              fontSize: "0.9rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Go home
          </button>
        </div>

        {eventId && (
          <p
            style={{
              marginTop: "2rem",
              fontSize: "0.75rem",
              opacity: 0.4,
              fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            }}
          >
            Reference: {eventId}
          </p>
        )}
      </div>
    </div>
  );
}
